import React from "react";
import { SwingLabAnalysisPage } from "@/features/swing-lab/pages/AnalysisPageSimple";
import { BottomTabs } from "../navigation/BottomTabs";

export default function AnalysisSummaryScreen() {
  // Show the summary/list view
  // Individual analysis details are handled by AnalysisDetailsScreen
  return (
    <div className="min-h-screen pb-24">
      <header className="bg-gradient-to-r from-[#0D382A] to-[#196644] px-6 py-4 flex items-center justify-center h-20 shadow-sm">
        <img 
          src="/nodoubles_logo_trans.png" 
          alt="No Doubles Golf Co" 
          className="h-12 object-contain"
        />
      </header>
      <SwingLabAnalysisPage />
      <BottomTabs />
    </div>
  );
}

